@import '../../scss/pk-accordion-group.variables';

:host {
  @apply invisible grid w-full opacity-0;
  font-family: var(--accordion--font-family);
  grid-template-rows: 0fr;
}

.item-content {
  @include transition(padding-top, var(--accordion--transition-duration), var(--accordion--transition-effect));
}

:host(.is-expanded) {
  @apply visible opacity-100;
  grid-template-rows: 1fr;

  .item-content {
    @apply animate-expand-collapse;
    animation-duration: var(--accordion--transition-duration);
  }
}

:host(:not(.no-transition)) {
  @include transition(
    #{var(--accordion--transition-properties)},
    var(--accordion--transition-duration),
    var(--accordion--transition-effect)
  );
}
